<template>
  <div class="btn-dropdown" :class="{ '_open' : menu_open }" @click.stop="toggleMenu()">
    <div class="btn-primary">
      Menu
      <i class="fal fa-chevron-up" v-if="menu_open"></i>
      <i class="fal fa-chevron-down" v-if="!menu_open"></i>
    </div>
    <div class="btn-dropdown-menu" @click.stop>
      <a href="/reports/account-activations">Account Activations</a>
      <a href="/reports/downloads">Downloads</a>
      <a href="/reports/enquiries">Enquiries</a>
<!--      <a href="/reports/company-types">Companies & Users - Company Types</a>-->
<!--      <a href="/reports/company-system-types">Companies & Users - System Types</a>-->
    </div>
  </div>
</template>

<script>

export default {
  async mounted() {
  },
  components: {
  },
  props: {
    'menu_open': {
      required: true,
    },
  },
  data() {
    return {
    }
  },
  methods: {
    toggleMenu() {
      if (this.menu_open) {
        this.$emit('close');
      } else {
        this.$emit('open');
      }
    },
  },
};
</script>